import { createSessionExpiryHandler } from "./sessionExpiry";

/**
 * AGRO landing : clés écrites à la connexion (Login.js, SetPassword.js) et état « auth » persisté
 * par redux-persist (clé « persist:root ») ; la langue et le pays choisis sont conservés.
 */
export const LANDING_SESSION_KEYS = ["token", "user", "tenantCode"];

export const purgePersistedAuth = (storage) => {
    try {
        const raw = storage.getItem("persist:root");
        if (!raw) return;
        const persisted = JSON.parse(raw);
        if (!("auth" in persisted)) return;
        delete persisted.auth;
        storage.setItem("persist:root", JSON.stringify(persisted));
    } catch {
        // état persisté illisible : laissé tel quel (le jeton est déjà retiré)
    }
};

export const onLandingSessionExpiry = createSessionExpiryHandler({
    sessionKeys: LANDING_SESSION_KEYS,
    purgePersistedAuth,
    loginPath: "/login",
    authPages: ["/login", "/signup", "/signup1", "/signup-success", "/forgot-password", "/reset-password", "/set-password"],
});

